import { getFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { type Layer } from '@/layers/layer';
import { type IRenderContextMenuItemArgs } from '@/plugins/context-menu';
import { GroupRoleType, LayerType, type IPuzzleLayer } from '@/version-types';

export const alignInnerItem = (
    { activeLayer, pickLayer, operateLayerType }: IRenderContextMenuItemArgs,
    identity: string,
) => {
    const { $t } = getLocaleStore();
    const framework = getFramework(identity);
    if (framework.service.edgelessCanvas.isEdgelessMode) return null;

    const layer = pickLayer || activeLayer;
    const disabled = !layer;
    if (disabled || operateLayerType !== LayerType.GROUP_LAYER) return null;

    const extension = framework.service.flatLayer.getGroupExtension<IPuzzleLayer>(layer);
    if (extension && extension.role === GroupRoleType.PUZZLE) return null;

    const clickHandler = (type: string) => {
        const dependenciesAPI = framework.service.registration.getInstance<Layer>('Layer');
        dependenciesAPI.groupAlign[type]?.(activeLayer?.id);
    };

    const item = {
        disabled,
        name: $t((v) => v.contextMenuLayer.menuConfig.alignElement),
        type: 'alignInner',
        childMenus: [
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.alignLeft),
                type: 'left',
                icon: 'AlignLeftBold',
                onClick: () => clickHandler('left'),
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.alignHorizontal),
                type: 'horizontalCenter',
                icon: 'AlignHorizontalCenterBold',
                onClick: () => clickHandler('horizontalCenter'),
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.alignRight),
                type: 'right',
                icon: 'AlignRightBold',
                onClick: () => clickHandler('right'),
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.alignTop),
                type: 'top',
                icon: 'AlignTopBold',
                onClick: () => clickHandler('top'),
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.alignVertical),
                type: 'verticalCenter',
                icon: 'AlignVerticalCenterBold',
                onClick: () => clickHandler('verticalCenter'),
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.alignBottom),
                type: 'bottom',
                icon: 'AlignBottomBold',
                onClick: () => clickHandler('bottom'),
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.horizontalDistribution),
                disabled: !!(activeLayer?.children.length && activeLayer?.children.length < 3),
                type: 'horizontalDistribution',
                icon: 'HorizontalDistributionBold',
                onClick: () => clickHandler('horizontalDistribution'),
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.verticalDistribution),
                disabled: !!(activeLayer?.children.length && activeLayer?.children.length < 3),
                type: 'verticalDistribution',
                icon: 'VerticalDistributionBold',
                onClick: () => clickHandler('verticalDistribution'),
            },
        ],
    };

    return item;
};
